import get from 'lodash/get'
import { Chains } from 'modules/blockChain/chains'

const BRIDGE_LINKS = {
  [Chains.Polygon]: 'https://wallet.polygon.technology/bridge/',
}

export function getLinkBridge(chainId: Chains) {
  return get(BRIDGE_LINKS, chainId)
}
